import { render, staticRenderFns } from "./OdontogramaArcadaSuperior.vue?vue&type=template&id=4e0e03f2&scoped=true"
import script from "./OdontogramaArcadaSuperior.vue?vue&type=script&lang=js"
export * from "./OdontogramaArcadaSuperior.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaArcadaSuperior.vue?vue&type=style&index=0&id=4e0e03f2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0e03f2",
  null
  
)

export default component.exports